import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Text, useThemeContext } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '../../hooks/useMediaQuery';
export function ConnectedWalletsEmptyState() {
    const { t } = useTranslation();
    const { appearance } = useThemeContext();
    /*
     * Illustration is 198x200 on mobile and 300x300 at >=640px. Styled inline
     * because the profile package has no CSS pipeline (no CSS modules).
     */
    const isWideViewport = useMediaQuery('(min-width: 640px)');
    const emptyImage = appearance === 'dark'
        ? '/imgs/illustrations/profile-wallets-modal-unlinked-wallets-empty-dark.svg'
        : '/imgs/illustrations/profile-wallets-modal-unlinked-wallets-empty-light.svg';
    return (_jsxs(Flex, { direction: "column", align: "center", gap: "5", py: "6", width: "100%", children: [_jsx("img", { src: emptyImage, alt: t('All connected wallets are already linked to your profile.'), style: isWideViewport ? { width: 300, height: 300 } : { width: 198, height: 200 } }), _jsx(Text, { size: "2", color: "gray", align: "center", children: t('All connected wallets are already linked to your profile.') })] }));
}
